import Card from 'react-bootstrap/Card';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { Fade, Stack } from 'react-bootstrap';
import { IconButton, TextButton } from 'Components/Button';
import { NumberedSteps } from 'Components/Public/NumberedSteps/NumberedSteps';
import { ArrowRight, Close, Favorite, ThumbDown, ThumbDownAltOutlined, ThumbUp, ThumbUpAltOutlined } from '@mui/icons-material';
import reCAPTCHA from 'Images/recaptchaimg.png';
import ahrqlogo from 'Images/ahrqlogo.png';
import psoppclogo from 'Images/psoppclogo.png';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { useState } from 'react';

export const DidFindPrompt = ({ title, text, children }) => {
    const [isDownHovered, setIsDownHovered] = useState(false);
    const [isUpHovered, setIsUpHovered] = useState(false);

    const [isDownSelected, setIsDownSelected] = useState(false);
    const [isUpSelected, setIsUpSelected] = useState(false);

     const [feedbackCharCount, setFeedbackCharCount] = useState(0);
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [feedbackErrors, setFeedbackErrors] = useState(null);
  const [isFeedbackLoading, setIsFeedbackLoading] = useState(false);

    const toggleSelected = (type) => {
        //console.log(type);
        if(type==="up"){
            if(isUpSelected==true){
                setIsUpSelected(false);
            }
            else{
                setIsUpSelected(true);
                setIsDownSelected(false);
            }
        }
        if(type==="down"){
            if(isDownSelected==true){
                setIsDownSelected(false);
            }
            else{
                setIsDownSelected(true);
                setIsUpSelected(false);
            }
        }
    }

    const handleSubmit = async () => {

    }

    const handleClearFeedback = () => {
        setFeedbackErrors(null);
        setFeedbackMessage('');
        setFeedbackCharCount(0);
    }
    
    const onFeedbackChange = (e) => {

        var content = e.target.value;
        var text = content.substring(0,2000);
        setFeedbackErrors(null);
        setFeedbackMessage(text);
        setFeedbackCharCount(text.length);
    }

    var displayErrors = (errors) => {
         return (
            <div>
                {errors!=null && errors.length > 0 ? errors.map((errorText,index) => 
                    <Stack key={ "Errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                        <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>

                        <div>{errorText}</div>
                    </Stack>
                    
                ) : null}
            </div>
        );
    }

    return (
        <>
        </>
        // <Row className="did-find-prompt-container align-items-center">
        //     <h3 className="mt-5">Did you find what you were looking for?</h3>

        //     <Stack direction="horizontal" gap='4' className="justify-content-center mb-2">
                
        //         <IconButton
        //             hiddenText={"Thumbs Up Button"}
        //             className="p-0"
        //             variant="clear"
        //             onMouseEnter={() => setIsUpHovered(true)}
        //             onMouseLeave={() => setIsUpHovered(false)}
        //             onClick={()=>toggleSelected("up")}
        //             icon={isUpSelected ? <ThumbUp /> : <ThumbUpAltOutlined />}
        //         >
        //         </IconButton>
        //         <IconButton
        //             hiddenText={"Thumbs Down Button"}
        //             className="p-0"
        //             variant="clear"
        //             onMouseEnter={() => setIsDownHovered(true)}
        //             onMouseLeave={() => setIsDownHovered(false)}
        //             onClick={()=>toggleSelected("down")}
        //             icon={isDownSelected ? <ThumbDown/> : <ThumbDownAltOutlined />}
        //         >
        //         </IconButton>
                
        //     </Stack>
        //     {isDownSelected || isUpSelected
        //         ?   <Fade in={(isDownSelected || isUpSelected)} appear={true}>
        //             <Col lg={7} className="page-feedback-form">
        //                 <Form>
        //                     <Form.Group>
        //                         <Form.Label htmlFor={"page-feedback"} className="visually-hidden">
        //                             Please enter your feedback:
        //                         </Form.Label> 
        //                         <div className="page-feedback-container">
        //                             <IconButton
        //                                 hiddenText={"Clear Feedback"}
        //                                 className=""
        //                                 variant="clear"
                                        
        //                                 onClick={handleClearFeedback}
        //                                 icon={<Close/>}
        //                             >
        //                             </IconButton>
        //                             <Form.Control 
        //                                 id="page-feedback"
        //                                 as="textarea" 
        //                                 onChange = {onFeedbackChange}
        //                                 onInput = {onFeedbackChange}
        //                                 rows={4}
        //                                 placeholder="How was your experience? (Optional)"
        //                                 value={feedbackMessage}
                                        
        //                             >
        //                             </Form.Control>
        //                         </div>
        //                         <Form.Text className="d-flex justify-content-end ">
        //                             {feedbackCharCount}/2000 characters
        //                         </Form.Text>
        //                         <Form.Control.Feedback tabIndex={-1} className={feedbackErrors!=null && feedbackErrors.length>0 ? "is-invalid mt-0 mb-3 lh-sm" : ""} type="invalid">
        //                         {displayErrors(feedbackErrors)} 
        //                         </Form.Control.Feedback>
                                
        //                     </Form.Group>
        //                     <Stack className="pt-3 justify-content-end" direction="horizontal" gap={3}>
                                
        //                         <TextButton
        //                             variant="normal"
        //                             onClick={handleSubmit}
        //                             content={"Submit"}
        //                         >
        //                         </TextButton>

                                
        //                     </Stack>
        //                 </Form>
        //             </Col>
        //         </Fade>
        //         : null
        //     }
            

        //     <h3 className="mt-5 pt-5">Still need help?</h3>
        //     <p>Contact technical support at <a href= "mailto:support@psoppc.org" className="supportEmail">support@psoppc.org</a>.</p>
        // </Row>
    );
}